module.exports = __webpack_public_path__ + "static/media/folder-plus.9fc56753.svg";